import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-manage-plants',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-plants.component.html',
    styleUrl: './manage-plants.component.scss'
})
export class ManagePlantsComponent {
  plantData: any = []
  exportData: any = []
  newPlantName: any = ''
  newMaximoCode: any = ''
  isLoading: boolean = false;
  SaveSuccess = false;
  errorData = false;
  constructor(private adminService: AdminService, private commonService: CommonService,private  messageService: NotificationService) {
    this.isLoading = true;
    this.setPlantData();
  }

  setPlantData() {
    this.isLoading = true;
    this.adminService.getAllUserInteractions('ManagePlants').subscribe((response: any) => {
      this.plantData = response;
      this.processData();
      this.setExportData(response);
    });
  }

  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecId: item.RecID,
      FacilityID: item.FacilityID,
      PlantName: item.PlantName,
      PlantMaximo: item.PlantMaximo,
      PlantRetired: item.PlantRetired
    }));
  }

  processData() {
    this.plantData.forEach((plant: any) => {
      if (plant.PlantRetired == 'True') {
        plant.status = 'Inactive';
        plant.buttonName = 'Unretire'
      } else {
        plant.status = 'Active';
        plant.buttonName = 'Retire'
      }
    });
    this.isLoading = false;
  }
  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }

  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {
      let payload = {
        "region": "Plant",
        "recID": row.RecID,
        "retired": row.PlantRetired == 'True' ? false : true
      }
      this.adminService.RETIREUSERINTERACTION(payload).subscribe({
        next: (message: any) => {
          this.messageService.showSuccess(message.message);
          this.setPlantData();
        }
      })
    }
  }

  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-Plant.xlsx','TLRAdmin-Plant');
    this.messageService.showSuccess("file downloaded successfully" );

  }

  addPlant() {
    this.errorData = false;
    this.SaveSuccess = false;
    if (this.newPlantName == '' || this.newMaximoCode == '') {
      this.errorData = true;
      this.messageService.showError("Please fill all the fields" );
      return;
    }
    let payload = {
      region: "Plant",
      data: {
        PlantName: this.newPlantName,
        PlantMaximo: this.newMaximoCode,
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }

    this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.messageService.showSuccess( message );
        this.newPlantName = '';
        this.newMaximoCode = '';
        this.setPlantData();
      }
    })
  }
}
